/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkReportListRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkReportListRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkReportListRequest>): WellArchitectedFrameworkReportListRequest {
        let obj = Object.assign(new WellArchitectedFrameworkReportListRequest(), model);
        WellArchitectedFrameworkReportListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkReportListRequest>): WellArchitectedFrameworkReportListRequest {
        if (!model) return null;
        return WellArchitectedFrameworkReportListRequest.newInstance(<WellArchitectedFrameworkReportListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkReportListRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkReportListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkReportListRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkReportListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.WellArchitectedFrameworkReportListFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Filters for the request
     */
    filters: models.WellArchitectedFrameworkReportListFilter;

}
